const CLIENTS = [
  { name: "Airtel", logo: "/clients/airtel.webp" },
  { name: "Bajaj Allianz", logo: "/clients/bajaj-allianz.webp" },
  { name: "Adani", logo: "/clients/adani.webp" },
  { name: "Tata Motors", logo: "/clients/tata-motors.webp" },
  { name: "Ultratech Cement", logo: "/clients/ultratech.webp" },
  { name: "ACC", logo: "/clients/acc.webp" },
  { name: "Reliance", logo: "/clients/reliance.webp" },
  { name: "Tata Power", logo: "/clients/tata-power.webp" },
  { name: "VI (Vodafone Idea)", logo: "/clients/vi.webp" },
  { name: "Ambuja Cement", logo: "/clients/ambuja.webp" },
];

export function ClientsMarquee() {
  const loop = [...CLIENTS, ...CLIENTS];
  return (
    <section className="w-full border-t border-border py-12 sm:py-16" data-testid="clients-section">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-xs font-bold uppercase tracking-widest text-primary mb-2">Clients</div>
        <h2 className="font-heading font-black text-3xl sm:text-4xl tracking-tight" data-testid="clients-title">Our Trusted Clients</h2>
        <p className="text-muted-foreground mt-2" data-testid="clients-subtitle">Proud to serve India's leading brands.</p>
      </div>
      <div className="mt-8 relative overflow-hidden marquee-mask" data-testid="clients-marquee">
        <div className="flex w-max items-center gap-4 animate-marquee hover:[animation-play-state:paused] py-2">
          {loop.map((c, i) => (
            <div key={`${c.name}-${i}`} aria-hidden={i >= CLIENTS.length}
              className="shrink-0 h-20 w-44 sm:h-24 sm:w-52 rounded-xl bg-white shadow-md shadow-black/10 border border-slate-200 flex items-center justify-center overflow-hidden px-5 py-3"
              data-testid={i < CLIENTS.length ? `client-badge-${i}` : undefined}>
              {c.logo ? (
                <img src={c.logo} alt={c.name} loading="lazy" className="h-full w-full object-contain" />
              ) : (
                <span className="text-[#0A2A5E] font-heading font-black text-sm sm:text-base text-center leading-tight">{c.name}</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ClientsMarquee;
